    import React, { Component } from "react";
    import Card from "../../../../components/common/Card.js";
    import CardHeader from "../../../../components/common/CardHeader.js";
    import CardBody from "../../../../components/common/CardBody.js";
    import CardTitle from "../../../../components/common/CardTitle.js";
    import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell
    } from "@mui/material";
    import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
    import Modal from "react-bootstrap/Modal";
    import Button from "react-bootstrap/Button";
    import Spinner from "react-bootstrap/Spinner";
    import "../../../../components/admin/css/common.css";
    import { sweetStatusAlert } from "../../../../components/common/SweetAlert.js";
    import Col from "react-bootstrap/Col";
    import Form from "react-bootstrap/Form";
    import Row from "react-bootstrap/Row";
    import { TransactionService } from "../../../../service/manage/subscription/transaction.service.js";
    import { ExamTransactionService } from "../../../../service/manage/exam_subscription/examTransaction.service.js"
    import { AssessmentCreditService } from "../../../../service/manage/exam_subscription/assessCredit.service.js";
    import TimeZoneHandler from "../../../../handlers/TimeZoneHandler.js";
    import debounce from "lodash.debounce";
    import { CreditService } from "../../../../service/manage/subscription/credit.service.js";
    import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";

    export default class ExamTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
        isTableDataLoading: false,
        isStudentListLoading: false,
        breadcrumb2: null,
        nodeTitle: null,
        flg_list_active: null,
        transactions: "",
        showModal: false,
        selectedTransaction: null,
        transactionsPrivilege: null,
        currentPage: 0,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        totalTransactions: 10,
        search_term: "",
        isDropHidden: false,
        studentlist: [],
        selectedStudent: this.props.studentId,
        userType: "",
        userIDs: "",
        };
        this.debouncedHandleSearchAll = debounce(this.getAllTransactions, 1000);
        this.debouncedHandleSearchUser = debounce(
            this.getAllTransactionsByUser,
            1000
        );
    }

    componentDidMount() {
        const { transactionsPrivilege } = this.state;
        const { breadcrumb2 = null, nodeTitle = null, flg_list_active = 1 } =
            this.props.props || {};
        const userType = sessionStorage.getItem("userType");

        this.setState(
            {
                breadcrumb2: breadcrumb2,
                nodeTitle: nodeTitle || "Assessment Subscriptions",
                flg_list_active: flg_list_active || 1,
                userType: userType,
                transactionsPrivilege: this.props.transactionsPrivilege,
            },
        () => {
            const { transactionsPrivilege } = this.state;
        if (userType === "admin") {
            this.getAllTransactions();
        } else if (userType === "student") {
            this.getAllTransactionsByUser(sessionStorage.getItem("manage_user_id"));
        } else if (userType === "parent") {
            if (flg_list_active === 1) {
                this.setState({ isDropHidden: true });
            }
            this.getAllTransactionsByUser(this.state.selectedStudent);
            
        }
            }
        );
    }

    getAllTransactionsByUser(user_id) {
        const mid = 100;
        const limit = this.state.limit;
		const offset = this.state.offset;
		const search_term = "" 
        const transaction_type = "exam";
        // const user_id = sessionStorage.getItem("manage_user_id");
        this.setState({ isTableDataLoading: true });
        ExamTransactionService.getAllExamTransactionsByUser(
        mid,
        user_id,
        limit,
        transaction_type,
        offset,
        search_term
        )
        .then((res) => {
            if (res.success) {
            this.setState({
                transactions: res.data.transactions,
                totalTransactions: parseInt(res.data.count),
            });
            } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching Exam Transactions. Please refresh the screen!",
                "error"
            );
            }
        })
        .finally(() => {
            this.setState({
            isTableDataLoading: false,
            });
        });
    }


    getAllTransactions() {
    const mid = 100;
    const { limit, offset, search_term } = this.state;
    this.setState({ isTableDataLoading: true });
    const transaction_type = "exam";
    ExamTransactionService.getAllTransactions(mid, limit, transaction_type, offset, search_term)
        .then((res) => {
        if (res.success) {
            this.setState({
            transactions: res.data.transactions,
            totalTransactions: parseInt(res.data.count),
            });
        } else {
            sweetStatusAlert(
            "Failed!",
            "Error fetching Transactions. Please refresh the screen!",
            "error"
            );
        }
        })
        .finally(() => {
        this.setState({
            isTableDataLoading: false,
        });
        });
    }

    handleBack = () => {
        if (this.props.onBack) {
        this.props.onBack();
        }
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value, isModified: true }));
    };

    handleRowClick = (transaction) => {
        this.setState({
        showModal: true,
        selectedTransaction: transaction.transaction,
        });
    };

    handleModalClose = () => {
        this.setState({
        showModal: false,
        selectedTransaction: null,
        });
    };

    handlePageChange = (event, newPage) => {
        const { limit } = this.state;
        const newOffset = newPage * limit;
        this.setState(
        {
            offset: newOffset,
            isTableDataLoading: true,
            currentPage: newPage,
        },
        () => {
            if (this.state.userType === "admin") {
                this.getAllTransactions();
            }else{
                this.getAllTransactionsByUser(this.state.selectedStudent);
            }
        }
        );
    };
    fetchallstudent = () => {
        const mid = 100;
		const lg_user_id = sessionStorage.getItem("manage_user_id");
		const lg_user_table_id = sessionStorage.getItem("table_log_id");
		const form_list_id = 29;
        const { search_term } = this.state;

        this.setState({ isStudentListLoading: true });
        AssessmentCreditService.getAllStudentsForParent(
        mid,
        form_list_id,
        sessionStorage.getItem("parent_group_id"),
        sessionStorage.getItem("parent_group_user_table_id"),
        search_term,
        "parent"
        )
        .then((response) => {
            if (response.success) {
            const userIDs = response.data.students.map(
                (student) => student.user_id
            );
            this.setState({
                studentlist: response.data.students,
                userIDs: userIDs,
            });
            this.getAllTransactionsByUser(userIDs);
            } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching students. Please refresh the screen!",
                "error"
            );
            }
        })
        .catch((error) => {
            sweetStatusAlert(
            "Failed!",
            "Error fetching students. Please refresh the screen!",
            "error"
            );
        })
        .finally(() => {
            this.setState({ isStudentListLoading: false });
        });
    };

    handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
        {
            offset: newOffset,
            isTableDataLoading: true,
            currentPage: newPage
        },
        () => {
            if (this.state.userType === "admin") {
                this.getAllTransactions();
            }else{
                this.getAllTransactionsByUser(this.state.selectedStudent);
            }
        }
        );
    };

    // handle the data fetching as per the data per page limit gets changes
    handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.offset / newLimit);
        this.setState(
        {
            limit: newLimit,
            offset: newLimit * newPage,
            isTableDataLoading: true,
            currentPage: newPage,
        },
        () => {
            if (this.state.userType === "admin") {
                this.getAllTransactions();
            }else{
                this.getAllTransactionsByUser(this.state.selectedStudent);
            }
        }
        );
    };

    handleSearch = (event) => {
        const search_term = event.target.value.trim();
        const userType = sessionStorage.getItem("userType");

        this.setState(
        {
            search_term,
            isTableDataLoading: true,
            offset: 0,
            currentPage: 0,
        },
        () => {
            const { transactionsPrivilege } = this.state;
            if (userType === "admin") {
            this.debouncedHandleSearchAll();
            } else {
            this.debouncedHandleSearchUser();
            }
        }
        );
    };
    handleStudentSelect = (event) => {
        if (!event.target.value) {
        this.setState({ selectedStudent: "" });
        this.getAllTransactionsByUser(this.state.userIDs);
        return;
        }
        let student = this.state.studentlist.find(
        (student) => student.user_id === event.target.value
        );
        this.setState({ isTableDataLoading: true });
        const selectedStudent = student.user_id;
        if (selectedStudent) {
        this.setState({ selectedStudent }, () => {
            this.getAllTransactionsByUser(selectedStudent);
        });
        }
    };

    clearStudentFilter = () => {
        this.setState({ selectedStudent: "" });
        this.getAllTransactionsByUser(this.state.userIDs);
    };

    render() {
        const {
        isTableDataLoading,
        transactions,
        showModal,
        selectedTransaction,
        transactionsPrivilege,
        currentPage,
        limit,
        totalTransactions,
        selectedStudent,
        isDropHidden,
        studentlist,
        isStudentListLoading,
        userType,
        } = this.state;


        return (
        <>
            <Card>
            {userType !== "student" && (
                <CardHeader>
                {userType === "admin" && (
                    <div>
                    {/* <CardTitle cardLabel={history.location.state.form_display_title} /> */}
                    <CardTitle cardLabel={"User Assessment Purchasings"} />
                    {/* <h3 style={{ color: 'gray' }}>{(breadcrumb2 || nodeTitle) ? `(${breadcrumb2 && breadcrumb2}${nodeTitle && nodeTitle})` : undefined}</h3> */}
                    </div>
                )}
                {/* {isDropHidden ? (
                    <div className="col-md-12 d-flex justify-content-start align-items-center px-0">
                    <div className="dropdown mb-2 px-0 col-md-4">
                        <>
                        {userType === "parent" && !selectedStudent && (
                            <h3 className="thead">Please select the student</h3>
                        )}
                        <Form.Group
                            as={Col}
                            md="12"
                            controlId="exampleForm.ControlInput3"
                            className="px-0"
                        >
                            <Form.Select
                            aria-label="Select the student"
                            name="student_id"
                            value={selectedStudent}
                            onChange={this.handleStudentSelect}
                            >
                            <option
                                value=""
                                style={{ fontFamily: "Poppins, sans-serif" }}
                            >
                                All Students
                            </option>
                            {studentlist.map((student) => (
                                <option key={student.user_id} value={student.user_id}>
                                {student.data_concat}
                                </option>
                            ))}
                            </Form.Select>
                        </Form.Group>
                        </>
                    </div>
                    {selectedStudent && (
                        <Button
                        variant="secondary"
                        onClick={this.clearStudentFilter}
                        className="ml-5"
                        >
                        Clear
                        </Button>
                    )}
                    </div>
                ) : null} */}

                </CardHeader>
            )}
            <CardBody>
                {transactions && (
                <div className="row">
                    {userType === "admin" && (
                    <div className="col-md-6 d-flex align-items-end">
                        <Form.Group
                        controlId="exampleForm.ControlInput1"
                        className="col-md-8 mb-2 px-0"
                        >
                        <Form.Control
                            type="text"
                            placeholder="Search"
                            onChange={this.handleSearch}
                            className="search-bar"
                        />
                        </Form.Group>
                    </div>
                    )}
                </div>
                )}
                {isStudentListLoading && (
                <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading ? (
                <div className="loading-container">
                    <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
                ) : (
                <div>
                    {(userType === "student" || userType === "parent")  && (
                            <CardHeader>
                            <div className="d-flex align-items-center">
                                <Button 
                                variant="link" 
                                onClick={this.handleBack}
                                className="mr-3"
                                >
                                &larr; Back to My Subscriptions
                                </Button>
                                {/* <CardTitle cardLabel="Back to Credit History" /> */}
                            </div>
                            </CardHeader>
                        )}
                    {!isStudentListLoading && transactions.length === 0 ? (
                    <Form.Label
                        style={{ fontSize: "large", marginBottom: "0" }}
                        className="pt-5"
                    >
                        No Exam Transactions Found!
                    </Form.Label>
                    ) : (
                    transactions && (
                        <div style={{ overflow: "Auto" }}>
                        <Table>
                            <TableHead>
                            <TableRow>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Confirmation No
                                </TableCell>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Assessment Name
                                </TableCell>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                No Of Credits
                                </TableCell>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Purchased Date
                                </TableCell>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Amount
                                </TableCell>
                                {userType === "admin" && (
                                <TableCell
                                    className="thead"
                                    style={{ textAlign: "center" }}
                                >
                                    Currency Type
                                </TableCell>
                                )}
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Paid By
                                </TableCell>
                                <TableCell
                                className="thead"
                                style={{ textAlign: "center" }}
                                >
                                Payment Method
                                </TableCell>
                                {userType !== "student" && (
                                <TableCell
                                    className="thead"
                                    style={{ textAlign: "center" }}
                                >
                                    Student No
                                </TableCell>
                                )}
                                {userType !== "student" && (
                                <TableCell
                                    className="thead"
                                    style={{ textAlign: "center" }}
                                >
                                    Student Name
                                </TableCell>
                                )}
                            </TableRow>
                            </TableHead>

                            <TableBody>
                            {transactions.length > 0 &&
                                transactions.map((transaction) => (
                                <TableRow>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.exam_transaction_id}
                                    </TableCell>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.assess_name}
                                    </TableCell>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.credits}
                                    </TableCell>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {TimeZoneHandler.convertTime(
                                        transaction.created_at
                                    )}
                                    </TableCell>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.symbol} {transaction.amount}
                                    </TableCell>
                                    {userType === "admin" && (
                                    <TableCell
                                        className="tData"
                                        style={{ textAlign: "center" }}
                                    >
                                        {transaction.currencyName}
                                    </TableCell>
                                    )}
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.paid_by}
                                    </TableCell>
                                    <TableCell
                                    className="tData"
                                    style={{ textAlign: "center" }}
                                    >
                                    {transaction.payment_method}
                                    </TableCell>
                                    {userType !== "student" && (
                                    <TableCell
                                        className="tData"
                                        style={{ textAlign: "center" }}
                                    >
                                        {transaction.user_code}
                                    </TableCell>
                                    )}
                                    {userType !== "student" && (
                                    <TableCell
                                        className="tData"
                                        style={{ textAlign: "center" }}
                                    >
                                        {transaction.student}
                                    </TableCell>
                                    )}
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <MaterialCustomTablePagination
                            totalCount={totalTransactions}
                            currentPage={currentPage}
                            limit={limit}
                            handlePageChange={this.handlePageChange}
                            handleRowsPerPageChange={this.handleRowsPerPageChange}
                            handlePageOffsetChange={this.handlePageOffsetChange}
                            rowsPerPageOptions={[5, 10, 20]}
                            offset={this.state.offset}
                        />
                        </div>
                    )
                    )}
                </div>
                )}
            </CardBody>
            </Card>

            <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showModal}
            onHide={this.handleModalClose}
            >
            <Modal.Header closeButton>
                <Modal.Title>Transaction Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedTransaction && (
                <Form>
                    {Object.entries(selectedTransaction).map(([key, value]) => (
                    <Row className="my-3" key={key}>
                        <Form.Label as={Col} md="3">
                        {key}
                        </Form.Label>
                        <Form.Label as={Col} md="9">
                        {key == "Exp. Date" || key == "Purchase Date"
                            ? TimeZoneHandler.convertTime(value)
                            : value}
                        </Form.Label>
                    </Row>
                    ))}
                </Form>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.handleModalClose}>
                Close
                </Button>
            </Modal.Footer>
            </Modal>
        </>
        );
    }
    }
